export function initHeaderScroll() {
	const $ = window.jQuery;

	$(function () {
		var lastScrollTop = 0,
			delta = 15;
		$(window).scroll(function () {
			var st = $(this).scrollTop();

			if (Math.abs(lastScrollTop - st) <= delta) return;
			if (st > lastScrollTop && lastScrollTop > 0) {
				// downscroll code
				$('.erd_header').css('top', '-8.75rem');
				$('.news-side-item').css('top', '1rem');
			} else {
				// upscroll code
				$('.erd_header').css('top', '0px');
				$('.news-side-item').css('top', '8rem');
			}
			lastScrollTop = st;
		});
	});
}
